import type { TestSuiteRunId } from "../contracts/testTriggerTypes";

export class TestSuiteRunIdFactory {
  makeTestSuiteRunId(): TestSuiteRunId {
    return `tsr_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
  }
}
